import { LoadingButton } from "@mui/lab";
import { Divider } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { I18nTranslator, translations } from "utils/i18n";

interface IProps extends DialogProps {
  open: boolean;
  title: string;
  onCancel: () => void;
  onOk: (value?: any) => void;
  hiddenBtnOK?: boolean;
  hiddenBtnCancel?: boolean;
  cancelText?: string;
  okText?: string;
  disabledBtnOK?: boolean;
  loading?: boolean;
}

const AppModal: React.FC<IProps> = ({
  open,
  title,
  onCancel,
  onOk,
  hiddenBtnOK,
  hiddenBtnCancel,
  disabledBtnOK,
  maxWidth,
  cancelText = I18nTranslator(translations.button.close),
  okText = I18nTranslator(translations.button.confirm),
  children,
  loading,
  sx,
}) => {
  const handleClose = (event: any, reason: string) => {
    // if (reason && reason === "backdropClick") return;
    onCancel();
  };
  return (
    <Dialog sx={sx} open={open} onClose={handleClose} maxWidth={"lg"}>
      <DialogTitle
        style={{ textAlign: "center", fontSize: 22, fontWeight: "bold" }}
      >
        {title}
      </DialogTitle>
      <Divider />
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        {hiddenBtnCancel ? null : (
          <Button onClick={onCancel}>{cancelText}</Button>
        )}
        {hiddenBtnOK ? null : (
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={onOk}
            disabled={disabledBtnOK}
          >
            {okText}
          </LoadingButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AppModal;
